import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

export class RoleRecord {
  constructor (record) {
    this._record = record

    this.id = _get(record, 'id', '')
    this.type = _get(record, 'type', '')
    this.description = _get(record, 'description', '')
    this.name = _get(record, 'name', '')
    this.permissions = _get(record, 'permissions', '')

    if (this.isNotEmptyPermissions) {
      this.parsePermissions()
    }
  }

  /**
   * Sets formatted uniq permissions for covenient using
  */
  parsePermissions () {
    const uniqResources = [...new Set(this.permissions.map(
      item => item.resource))]

    this.permissions = uniqResources.map(resource => ({
      resource,
      actions: this.permissions
        .filter(item => item.resource === resource)
        .map(item => ({ type: item.action, value: true })),
    }))
  }

  /**
   * Formats "permissions" to initial record
   * state according to backend structure.
   * @return {array} of "permissions" {object} in initial format.
   */
  formatPermissions () {
    return this.permissions
      .map(permission =>
        permission.actions
          .filter(action => action.value)
          .map(item => ({
            resource: permission.resource,
            action: item.type,
          })))
      .flat()
  }

  get isNotEmptyPermissions () {
    return !_isEmpty(this.permissions)
  }
}
